<script>
    import { onMount } from "svelte";
    import Header from "../header.svelte";
    import { push } from "svelte-spa-router";
    import { api_host, user_store, billing_history_store } from "../../stores.js";
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from "../../utils/toast_message.js";
    import CreditCardEntry from "../../utils/creditcardentry.svelte";
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import { capitalizeFirst, formatDate, formatDateAndTime, sort_functions } from '../../utils/format.js';
    import { init_data } from "../../init.js";
    import Swal from "sweetalert2";


    let myself = {};
    user_store.subscribe(value => {
        myself = value;
        if (myself.role !== 'landscaper') {
            push('#/Settingscompany');
        }
    });

    let is_busy = false;
    let content_title = "Settings - Billing";
    let show_cc_entry = false, editing_cc_index = -1;
    let cc_number, cc_name, cc_cvc, cc_expiry;
    let is_cc_number_valid, is_cc_cvc_valid, is_cc_expiry_valid;
    let add_cc_entry = false;
    let new_cc_number, new_cc_name, new_cc_cvc, new_cc_expiry;
    let is_new_cc_number_valid, is_new_cc_cvc_valid, is_new_cc_expiry_valid;
    let billing_cards = [];
    let billing_history = [];

    const { auth_type, auth_token, domain_code } = getToken();

    const refresh_billing = async () => {
        is_busy = true;
        const res = await doFetch(
            `${api_host}/api/landscaper/billing/get`,
            'GET',
            null,
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (res.status) {
            billing_cards = res.billing_cards;
            billing_cards.sort((a, b) => {
                if (a.is_default) return -1;
                if (b.is_default) return 1;
                return 0;
            });
        } else {
            toast_message(false, res.msg || 'Failed', 2000);
        }
        is_busy = false;
    }

    billing_history_store.subscribe(value => {
        let _billing_history = [];
        for (let i = 0; i < value.length; i ++) {
            const history_item = value[i];
            _billing_history.push({
                'd': formatDateAndTime(new Date(history_item.date * 1000)),
                'dt': formatDate(new Date(history_item.date * 1000)),
                'sp': `${capitalizeFirst(history_item.plan_type)} / ${history_item.plan_freq}`,
                'amount': (history_item.amount / 100).toFixed(2),
                'desc': history_item.description,
            });
        }
        billing_history = _billing_history;
    });

    onMount(async () => {
        refresh_billing();
        init_data('billing_history');
    });

    let from_date, to_date;
    let history_header_config = [
        {'t': 'Date/Time', 'fm': 'd', 'date': 'd', 'a': true},
        {'t': 'Subscription plan', 'fm': 'sp', 'csv': 'csv_cn', 'a': true},
        {'t': 'Amount ($)', 'fm': 'amount', 'csv': 'csv_ad', 'a': true},
        {'t': 'Description', 'fm': 'desc', 'csv': 'csv_cr', 'a': true}
    ];
</script>


<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="section billininginfo">
        <div class="sectionsubtitle">Billing Information</div>
        {#if !show_cc_entry}
        <div class="billininginfotableholder">
            <table style="width: 100%;max-width: 750px;">
                <tr>
                    <th>Type</th>
                    <th>Number</th>
                    <th>Expiry</th>
                    <th></th>
                    <th>Action</th>
                </tr>
                {#each billing_cards as billing_card, cc_index}
                <tr>
                    <td style='text-transform: capitalize;'>{billing_card.cc_brand}</td>
                    <td>{billing_card.cc_number}</td>
                    <td>{billing_card.cc_expiry}</td>
                    <td>
                        <div
                            class={`${billing_card.is_default ? 'cc_default' : 'cc_set_default_btn'}`}
                            on:click={async () => {
                                if (!billing_card.is_default) {
                                    is_busy = true;
                                    const res = await doFetch(
                                        `${api_host}/api/landscaper/billing/set/default`,
                                        'POST',
                                        { 'paycard_id': billing_card.cc_id },
                                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                                    );
                                    if (res.status) {
                                        toast_message(true, res.msg, 2000);
                                        refresh_billing();
                                    } else {
                                        toast_message(false, res.msg || 'Failed set default card', 2000);
                                    }
                                    is_busy = false;
                                }
                            }}
                        >
                            {billing_card.is_default ? 'default' : 'set as default'}
                        </div>
                    </td>
                    <td>
                        <button class='cc_edit_btn' on:click={() => {
                            show_cc_entry = true;
                            editing_cc_index = cc_index;
                            cc_name = billing_cards[editing_cc_index].cc_name;
                            cc_number = billing_cards[editing_cc_index].cc_number;
                            cc_expiry = billing_cards[editing_cc_index].cc_expiry;
                            cc_cvc = billing_cards[editing_cc_index].cc_cvc;
                        }}>Edit</button>
                        {#if !billing_card.is_default}
                        <button class='cc_edit_btn cc_delete_button' on:click={async () => {
                            Swal.fire({
                                title: 'Delete Card?',
                                buttonsStyling: true,
                                confirmButtonClass: "button",
                                confirmButtonText: 'OK',
                                cancelButtonText: "Cancel",
                                showCancelButton: true,
                                icon: "warning"
                            }).then(async (e) => {
                                if (e.isConfirmed) {
                                    is_busy = true;
                                    const res = await doFetch(
                                        `${api_host}/api/landscaper/billing/delete`,
                                        'POST',
                                        { cc_id: billing_cards[cc_index].cc_id },
                                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                                    );
                                    if (res.status) {
                                        toast_message(true, res.msg, 2000);
                                        refresh_billing();
                                    } else {
                                        toast_message(false, res.msg || 'Failed', 2000);
                                    }
                                    is_busy = false;
                                }
                            });
                        }}>Delete</button>
                        {/if}
                    </td>
                </tr>
                {/each}
            </table>
        </div>
        {:else}
        <div class="sectioninfo">
            <div class="cardentryholder">
                <h6>Edit Card</h6>
                <CreditCardEntry
                    bind:cc_number={cc_number}
                    bind:cc_name={cc_name}
                    bind:cc_cvc={cc_cvc}
                    bind:cc_expiry={cc_expiry}
                    bind:is_cc_number_valid={is_cc_number_valid}
                    bind:is_cc_cvc_valid={is_cc_cvc_valid}
                    bind:is_cc_expiry_valid={is_cc_expiry_valid}
                />
                <button class="action" on:click={async () => {
                    if (cc_number.includes('*') || cc_cvc.includes('*')) {
                        is_cc_number_valid = false;
                        is_cc_cvc_valid = false;
                        return;
                    }
                    is_busy = true;
                    show_cc_entry = !show_cc_entry;
                    const res = await doFetch(
                        `${api_host}/api/landscaper/billing/update`,
                        'POST',
                        {
                            cc_id: billing_cards[editing_cc_index].cc_id,
                            cc_name: cc_name,
                            cc_number: cc_number,
                            cc_expiry: cc_expiry,
                            cc_cvc: cc_cvc
                        },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        refresh_billing();
                    } else {
                        toast_message(false, res.msg || 'Failed', 2000);
                    }
                    is_busy = false;
                }}>Save</button>
                <button class="cancel" on:click={() => { show_cc_entry = !show_cc_entry; }}>Cancel</button>
            </div>
            <br />
        </div>
        {/if}
        {#if !add_cc_entry}
            <div class="billininginfobuttonholder">
                <button class="action" on:click={() => { add_cc_entry = true; }}>Add Card</button>
            </div>
        {/if}
        {#if add_cc_entry}
            <div class="cardentryholder">
                <h5>Add Card</h5>
                <CreditCardEntry
                    bind:cc_number={new_cc_number}
                    bind:cc_name={new_cc_name}
                    bind:cc_cvc={new_cc_cvc}
                    bind:cc_expiry={new_cc_expiry}
                    bind:is_cc_number_valid={is_new_cc_number_valid}
                    bind:is_cc_cvc_valid={is_new_cc_cvc_valid}
                    bind:is_cc_expiry_valid={is_new_cc_expiry_valid}
                />
                <button class="action" on:click={async () => {
                    is_busy = true;
                    add_cc_entry = !add_cc_entry;
                    const res = await doFetch(
                        `${api_host}/api/landscaper/billing/add`,
                        'POST',
                        {
                            cc_name: new_cc_name, 
                            cc_number: new_cc_number,
                            cc_expiry: new_cc_expiry,
                            cc_cvc: new_cc_cvc
                        },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        refresh_billing();
                    } else {
                        toast_message(false, res.msg || 'Failed', 2000);
                    }
                    is_busy = false;
                }}>Save</button>
                <button class="cancel" on:click={() => { add_cc_entry = !add_cc_entry; }}>Cancel</button>
            </div>
        {/if}
    </div>

    <br />

    <div class="section">
        <div class="sectionsubtitle">Payment history</div>

        <ResponsiveTable 
            table_data={billing_history}
            num_per_page={100}
            show_csv_export={false}
            show_date_range={true}
            date_filter_param='dt'
            refresh_action='billing_history'
            sort_functions={sort_functions}
            bind:from_date={from_date}
            bind:to_date={to_date}
            bind:table_header_config={history_header_config}
            bind:total_items={billing_history.length}
        />
    </div>
</div>


<style>
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
        width: 100%;
    }
    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .section {
        border: 1px solid #1769aa;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
    }
    .cc_default {
        display: inline;
        background: lightgray;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
    .cc_set_default_btn {
        cursor: pointer;
        display: inline;
        background: green;
        color: white;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
        white-space: nowrap;
    }
    .cc_verify {
        cursor: pointer;
        display: inline;
        background: red;
        color: white;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
    .tooltip {
        position: relative;
        display: inline-block;
        border-bottom: 1px dotted black;
        opacity: 1;
    }
    .cc_default {
        display: inline;
        background: lightgray;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
    .cc_edit_btn {
        cursor: pointer;
        display: inline;
        background: green;
        color: white;
        border-radius: 5px;
        padding: 2px 7px 2px 7px;
    }
    .cc_delete_button {
        background: red;
    }
    .cc_set_default_btn {
        cursor: pointer;
        display: inline;
        background: #1769aa;
        color: white;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
</style>
